import React from "react";
import { CardFrame } from "../card-frame/CardFrame";
import styles from "./IconTabs.module.scss";

export interface IconTabItem {
	onTap: () => void;
	title: string;
	icon: React.ReactNode;
	disabled?: boolean;
}

interface IconTabsProps {
	tabs: IconTabItem[];
	selectedIndex: number | null;
	width?: number;
	headerSectionTitle?: string;
	headerSectionRightContent?: React.ReactNode;
	iconSize?: number;
	circleSize?: number;
	borderColor?: string;
}

export const IconTabs: React.FC<IconTabsProps> = ({
	tabs,
	selectedIndex,
	width,
	headerSectionTitle,
	headerSectionRightContent,
	iconSize = 28,
	circleSize = 56,
}) => {
	return (
		<CardFrame headerSectionTitle={headerSectionTitle} headerSectionRightContent={headerSectionRightContent} paddingBottom={0}>
			<div className={styles.tabRow}>
				{tabs.map((tab, i) => {
					const isSelected = i === selectedIndex;
					return (
						<React.Fragment key={i}>
							{i > 0 && <div className={styles.divider} />}
							<button
								className={[styles.tab, isSelected ? styles.tabSelected : "", tab.disabled ? styles.tabDisabled : ""].join(" ")}
								onClick={tab.disabled ? undefined : tab.onTap}
								style={width !== undefined ? { width } : undefined}
								disabled={tab.disabled}
							>
								<div className={[styles.iconCircle, isSelected ? styles.iconCircleSelected : ""].join(" ")} style={{ width: circleSize, height: circleSize }}>
									<div style={{ width: iconSize, height: iconSize, display: "flex", alignItems: "center", justifyContent: "center" }}>{tab.icon}</div>
								</div>
								<span className={[styles.tabTitle, isSelected ? styles.tabTitleSelected : ""].join(" ")}>{tab.title}</span>
							</button>
						</React.Fragment>
					);
				})}
			</div>
		</CardFrame>
	);
};
